import axiosInstance from '@/core/api'
import type {
	GetCryptoInvoicesRequest,
	GetCryptoInvoicesResponse,
	GetCryptoInvoiceByIdResponse,
	GeneratePaymentRequest,
	GeneratePaymentResponse,
	ConfirmTransactionRequest,
	ConfirmTransactionResponse,
	GetBillingDetailsRequest,
	GetBillingDetailsResponse,
	OverdueInvoiceCheckResponse,
	CreatePrepaymentInvoiceRequest,
	CreatePrepaymentInvoiceResponse,
} from '../../type'

export const getCryptoInvoices = async (
	payload: GetCryptoInvoicesRequest,
): Promise<GetCryptoInvoicesResponse> => {
	const response = await axiosInstance.get<GetCryptoInvoicesResponse>(
		'/admin/crypto-invoices',
		{ params: payload },
	)
	return response.data
}

export const getCryptoInvoiceById = async (
	id: string,
): Promise<GetCryptoInvoiceByIdResponse> => {
	const response = await axiosInstance.get<GetCryptoInvoiceByIdResponse>(
		`/admin/crypto-invoices/${id}`,
	)
	return response.data
}

export const generatePayment = async (
	payload: GeneratePaymentRequest,
): Promise<GeneratePaymentResponse> => {
	const response = await axiosInstance.post<GeneratePaymentResponse>(
		'/admin/crypto-invoices/generate-payment',
		payload,
	)
	return response.data
}

export const confirmTransaction = async (
	payload: ConfirmTransactionRequest,
): Promise<ConfirmTransactionResponse> => {
	const response = await axiosInstance.post<ConfirmTransactionResponse>(
		'/admin/crypto-invoices/confirm',
		payload,
	)
	return response.data
}

export const getBillingDetails = async (
	payload: GetBillingDetailsRequest,
): Promise<GetBillingDetailsResponse> => {
	const response = await axiosInstance.get<GetBillingDetailsResponse>(
		'/admin/crypto-invoices/billing-details',
		{ params: payload },
	)
	return response.data
}

export const createPrepaymentInvoice = async (
	payload: CreatePrepaymentInvoiceRequest,
): Promise<CreatePrepaymentInvoiceResponse> => {
	const response = await axiosInstance.post<CreatePrepaymentInvoiceResponse>(
		'/admin/crypto-invoices/create-prepayment',
		payload,
	)
	return response.data
}

export const checkOverdueInvoices =
	async (): Promise<OverdueInvoiceCheckResponse> => {
		const response = await axiosInstance.get<OverdueInvoiceCheckResponse>(
			'/admin/crypto-invoices/check-overdue',
		)
		return response.data
	}
